<template>
    <div class="deq-reset">
        <SingleTextOnlineProfileMetric v-if="profileMetrics && isSingleProfile" :is-single-profile="isSingleProfile" :profileMetric="profileMetrics[0]"/>
        <MultiTextOnlineProfileMetric v-if="profileMetrics && !isSingleProfile" :is-single-profile="isSingleProfile" :profile-metrics="profileMetrics"/>
    </div>

</template>


<script>
import {currentAccountCode} from "@/app/utils/Account";
import SingleTextOnlineProfileMetric
    from "@/dashboards/widgets/onlineprofile/textonlineprofile/SingleTextOnlineProfileMetric.vue";
import MultiTextOnlineProfileMetric
    from "@/dashboards/widgets/onlineprofile/textonlineprofile/MultiTextOnlineProfileMetric.vue";

export default {
    name: "TextOnlineProfileMetric",
    components: {MultiTextOnlineProfileMetric, SingleTextOnlineProfileMetric},
    props: {
        profileMetrics: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            chartData: [],
            loading: false,
            error: null,
            emptyMessage: 'Your filter has no profile information available',
            accountCode: currentAccountCode(),
            isSingleProfile: false,
            testData: {}
        }
    },

    mounted() {
        console.log('textOnlineProfileMetric mounted: ', this.profileMetrics)
    },

    watch: {
        profileMetrics(newProfileMetrics) {
            this.testData = newProfileMetrics;
            this.isSingleProfile = false;
        }
    }
}
</script>



<style scoped lang="sass">
.deq-reset
    color: unset
</style>